// removed by extract-text-webpack-plugin
module.exports = {"root":"Message_root_19t"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Message/Message.css
 ** module id = 567
 ** module chunks = 0
 **/